import {Component, Injectable, Output, EventEmitter, Input} from '@angular/core';
import {NgbDatepickerI18n, NgbDateParserFormatter, NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';
import { NgbDateFRParserFormatter } from './ngb-datepicker-fr-formatter';
 
const I18N_VALUES = {
    'fr-FR': {
        weekdays: ['Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa', 'Di'],
        months: ['Jan', 'Fév', 'Mar', 'Avr', 'Mai', 'Juin', 'Juil', 'Aou', 'Sep', 'Oct', 'Nov', 'Déc']
    }
    // other languages you would support
};
 
// Define a service holding the language. You probably already have one if your app is i18ned. Or you could also
// use the Angular LOCALE_ID value
@Injectable()
export class I18n {
    language = 'fr-FR';
}
 
// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
 
    constructor(private _i18n:I18n) {
        super();
    }
    getDayAriaLabel(date: NgbDateStruct): string {
        return `${date.day}-${date.month}-${date.year}`;
    }

    getWeekdayShortName(weekday:number):string {
        return I18N_VALUES[this._i18n.language].weekdays[weekday - 1];
    }
 
    getMonthShortName(month:number):string {
        return I18N_VALUES[this._i18n.language].months[month - 1];
    }
 
    getMonthFullName(month:number):string {
        return this.getMonthShortName(month);
    }
}

@Component({
    selector: 'ngbd-datepicker-I18n',
    templateUrl: './datepicker-I18n.html',
    providers: [
        I18n,
        {provide: NgbDatepickerI18n, useClass: CustomDatepickerI18n},
        {provide: NgbDateParserFormatter, useClass: NgbDateFRParserFormatter}
    ] 
  })
  export class NgbdDatepickerI18n {
    @Output('send') sendDate: EventEmitter<NgbDateStruct> = new EventEmitter<NgbDateStruct>();
    @Input('date') model: NgbDateStruct;

    onDateChoose() {
        // this.sendDate.emit(new Date(this.model.year, this.model.month, this.model.day));
        this.sendDate.emit(this.model);
    }

  }


// WEBPACK FOOTER //
// ./src/app/outils/datepicker-I18n.ts